import React from 'react';
import propTypes from './propTypes';

const MovementFields = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 2H15.7273L18.7576 6L15.7273 10H13L16.0303 6L13 2Z" fill="currentColor" />
    <path d="M17.2424 2H19.9697L23 6L19.9697 10H17.2424L20.2727 6L17.2424 2Z" fill="currentColor" />
    <path d="M13.2 5L7 5V3H5V5L3 5V7H5V17H3V19H5V21H7V19L17 19V21H19V19H21V17H19V12H17V17L7 17V7L13.2 7L14 6L13.2 5Z" fill="currentColor" />
  </svg>
);

MovementFields.propTypes = propTypes;

export default MovementFields;
